<template>

  <el-row>
    <el-row>
      <el-form :inline="true" :model="queryParam" class="demo-form-inline">

        <el-form-item>
          <el-select v-model="queryParam.clueType" clearable placeholder="线索类型">
            <el-option label="唯一线索" value="1"></el-option>
            <el-option label="重复线索" value="2"></el-option>
            <!--                        <el-option label="指定线索" value="3"></el-option>-->
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="queryParam.followStatus" clearable placeholder="跟进状态">
            <el-option label="待跟进" value="1"></el-option>
            <el-option label="有效线索" value="2"></el-option>
            <el-option label="无效线索" value="3"></el-option>
            <el-option label="成交" value="4"></el-option>
            <el-option label="再次跟进" value="5"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-belong-to-admin>
          <channel-select ref="channelSelect" clearable filterable placeholder="渠道来源"
                          @change="channelIdsChange"></channel-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="queryParam.sourceType" clearable filterable placeholder="线索来源">
            <!--                        <el-option :value="1" label="智能选车"></el-option>-->
            <!--                        <el-option :value="2" label="资讯详情"></el-option>-->
<!--            <el-option :value="3" label="新车评测"></el-option>-->
            <!--                        <el-option  label="汽车新闻" :value="4"></el-option>-->
<!--            <el-option :value="5" label="车系详情"></el-option>-->
            <el-option :value="6" label="帮我找车"></el-option>
            <!--                    <el-option  label="本地询价" :value="7"></el-option>-->
            <!--                    <el-option  label="首页询底价" :value="8"></el-option>-->
<!--            <el-option :value="9" label="车型对比"></el-option>-->
<!--            <el-option :value="10" label="购车计算"></el-option>-->
            <!--                    <el-option  label="购车顾问" :value="11"></el-option>-->
            <!--                    <el-option  label="弹窗询价" :value="12"></el-option>-->
            <!--                        <el-option :value="13" label="网上车展"></el-option>-->
            <el-option :value="14" label="高价卖车"></el-option>
            <el-option :value="15" label="车辆估价"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="queryParam.createTime" end-placeholder="询价结束时间" start-placeholder="询价开始时间"
                          type="daterange">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-input v-model="queryParam.keyword" placeholder="搜索车型、手机号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="loadList(1)">搜索</el-button>
          <el-button  type="warning" @click="exportExcel()">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table :data="datas" :row-style="{height:'60px'}" border style="width: 100%;">
        <el-table-column label="询价人">
          <template scope="scope">
            <div style="margin-left: 10px;height: 20px;">{{ scope.row.cluePersonPhone }}</div>
            <div style="margin-left: 10px;height: 20px;">{{ scope.row.cluePersonName }}</div>
            <div style="margin-left: 10px;height: 20px;" v-if="scope.row.outNetVal"> 外网编号:{{ scope.row.outNetVal }}</div>
          </template>
        </el-table-column>

        <el-table-column label="询价车型" width="240px">
          <template scope="scope">
            <div>
              <p>{{ scope.row.brand }} {{ scope.row.series }}</p>
              <p v-if="scope.row.category">{{ scope.row.category }}</p>
              <p v-if="scope.row.carPurchaseMode"> {{ scope.row.carPurchaseMode }}|{{ scope.row.boardAddress }}</p>
              <p v-else> {{ scope.row.boardAddress }}</p>
              <p v-if="scope.row.miles">行驶里程:{{ scope.row.miles }}万公里</p>
              <p v-if="scope.row.regdate">上牌日期:{{ scope.row.regdate }}</p>
            </div>

          </template>
        </el-table-column>
        <el-table-column label="线索来源">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sourceType|sourceTypeFilter }}</span>
          </template>
        </el-table-column>

        <el-table-column label="线索类型">
          <template scope="scope">
            <p :style="scope.row.clueType==2?'color:#F56C6C':''"> {{ scope.row.clueType | clueTypeFilter }}</p>
          </template>
        </el-table-column>
        <el-table-column label="询价时间 ">
          <template scope="scope">
            <p class=" text-nowrap">{{ scope.row.createTime | dateTimeFormat }}</p>
          </template>
        </el-table-column>

        <el-table-column v-if="isAdmin" label="渠道来源">
          <template scope="scope">
            <div style="margin-left: 10px;height: 20px;">{{ scope.row.channelPageName }}</div>
            <div style="margin-left: 10px;height: 20px;">{{ scope.row.channelName }}</div>
          </template>
        </el-table-column>
        <el-table-column  label="跟进状态">
          <template scope="scope">
            <span :style="scope.row.followStatus==1?'color:#E6A23C':scope.row.followStatus==3?'color:#F56C6C':scope.row.followStatus==4?'color:#67C23A':''">{{ scope.row.followStatus|followStatusFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="跟进备注">
          <template scope="scope">
            <el-row>
              <el-col> {{ scope.row.followRemark }}</el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-button size="mini" type="text"
                           @click="$router.push({path:'/home/saveClueFollowRemark',query:{'id':scope.row.id}})">
                  填写跟进
                </el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column v-if="isAdmin" label="官方备注">
          <template scope="scope">
            <p class=" text-nowrap">{{ scope.row.note }} </p>
            <el-button type="text" @click="editNote(scope.row.id)">{{ scope.row.remark ? '修改' : '备注' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="currentPage" :page-size="10" :total="total" class="row basic-margin"
                     layout="total, prev, pager, next, jumper" style="margin-left:0px" @current-change="fn"
                     @size-change="fn">
      </el-pagination>
    </el-row>
  </el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import ClueModel from '@/framework/models/clueModel'
import Config from '@/framework/configs/Config'
import channelSelect from '@/components/channelSelect'

export default {
  name: 'clue-management',
  extends: BasicPager,
  components: {
    channelSelect
  },
  data: function () {
    return {
      isAdmin: false,
      channelArr: [],
      queryParam: {
        clueState: null,
        clueType: null,
        clueEvaluateType: null,
        businessId: '',
        channelId: '',
        createTime: null,
        evaluateTime: null,
        lookTime: null,
        keyword: null,
        followStatus: null,
        carShowId: null
      },
      note: null,
      datas: [],
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  activated: function () {
    this.loadList(1)
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath !== 'channel'
    if (this.carShowId) {
      this.queryParam.carShowId = this.carShowId
    }
    this.loadList(1)
  },
  props: {
    carShowId: {
      type: Number,
      default: null
    }
  },
  watch: {
    'queryParam.clueState': function () {
      this.loadList(1)
    },
    'queryParam.followStatus': function () {
      this.loadList(1)
    },
    'queryParam.clueType': function () {
      this.loadList(1)
    },
    'queryParam.clueEvaluateType': function () {
      this.loadList(1)
    },
    'queryParam.businessId': function () {
      this.loadList(1)
    },
    'queryParam.channelId': function () {
      this.loadList(1)
    },
    'queryParam.sourceType': function () {
      this.loadList(1)
    },
    'queryParam.createTime': function () {
      this.loadList(1)
    },
    'queryParam.evaluateTime': function () {
      this.loadList(1)
    },
    'queryParam.lookTime': function () {
      this.loadList(1)
    },
    carShowId: function (newValue) {
      if (this.carShowId) {
        this.queryParam.carShowId = newValue
      }

      this.loadList(1)
    }
  },
  methods: {
    channelIdsChange: function (channelId) {
      this.queryParam.channelId = channelId
    },
    editNote: function (clueId) {
      this.$prompt('请输入线索备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '备注不能为空！ '
          })

          return
        }

        let _this = this
        let params = {
          clueId: clueId,
          note: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.loadList()
          },
          error: function () {
            _this.$message({
              type: 'error',
              message: '操作失败！ '
            })
          }
        }

        ClueModel.setClueNote(this, params, listener)
      })
    },
    fn: function (d) {
      this.loadList(d)
    },
    loadList: function (pageNumber) {
      let _this = this
      if (pageNumber) {
        _this.currentPage = pageNumber
      }
      // 如果为渠道商登陆 则设置查询渠道id为该渠道商
      if (_this.getLoginInfo().id) {
        _this.queryParam.channelId = _this.getLoginInfo().id
      }

      let params = {
        clueType: _this.queryParam.clueType,
        clueState: _this.queryParam.clueState,
        evaluateType: _this.queryParam.clueEvaluateType,
        businessId: _this.queryParam.businessId,
        channelId: _this.queryParam.channelId,
        sourceType: _this.queryParam.sourceType,
        startTime: null,
        endTime: null,
        start: _this.currentPage,
        length: 10,
        carShowId: _this.queryParam.carShowId,
        followStatus: _this.queryParam.followStatus
      }

      if (_this.queryParam.keyword) {
        params.keyword = _this.queryParam.keyword
      }

      if (_this.queryParam.createTime && _this.queryParam.createTime.length === 2) {
        let startTime = _this.queryParam.createTime[0]
        let endTime = _this.queryParam.createTime[1]

        if (startTime) {
          params.startTime = startTime.getTime()
        }

        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }
      if (_this.queryParam.evaluateTime && _this.queryParam.evaluateTime.length === 2) {
        let evaluateStartTime = _this.queryParam.evaluateTime[0]
        let evaluateEndTime = _this.queryParam.evaluateTime[1]

        if (evaluateStartTime) {
          params.evaluateStartTime = evaluateStartTime.getTime()
        }

        if (evaluateEndTime) {
          params.evaluateEndTime = evaluateEndTime.getTime()
        }
      }
      if (_this.queryParam.lookTime && _this.queryParam.lookTime.length === 2) {
        let lookStartTime = _this.queryParam.lookTime[0]
        let lookEndTime = _this.queryParam.lookTime[1]

        if (lookStartTime) {
          params.lookStartTime = lookStartTime.getTime()
        }

        if (lookEndTime) {
          params.lookEndTime = lookEndTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      ClueModel.findClue(_this, params, listener)
    },
    exportExcel: function () {
      let _this = this
      let userInfo = _this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let loginPath = userInfo.loginPath
      let params = {
        clueType: _this.queryParam.clueType,
        keyword: _this.queryParam.keyword,
        sourceType: _this.queryParam.sourceType,
        followStatus: _this.queryParam.followStatus,
        channelId: _this.isAdmin ? _this.queryParam.channelId : id

      }
      if (_this.queryParam.createTime && _this.queryParam.createTime.length === 2) {
        let startTime = _this.queryParam.createTime[0]
        let endTime = _this.queryParam.createTime[1]

        if (startTime) {
          params.startTime = startTime.getTime()
        }

        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let dataStr = JSON.stringify(params)

      window.location.href = Config.baseUrl + 'clue/exportExcel.action?param=' + encodeURI(dataStr) + '&token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath
    }
  },
  filters: {
    followStatusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '待跟进'

          break
        case 2:
          str = '有效线索'

          break
        case 3:
          str = '无效线索'
          break
        case 4:
          str = '成交'
          break
        case 5:
          str = '再次跟进'
          break
        default:
      }
      return str
    }

  }
}

</script>
